import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreText?: string;
  morePath?: string;
  accent?: 'primary' | 'secondary' | 'accent';
  children?: ReactNode;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreText,
  morePath,
  accent = 'primary',
}: SectionHeadingProps) {
  const accentClasses: Record<string, string> = {
    primary: 'bg-primary-500 text-background-50',
    secondary: 'bg-secondary-500 text-background-50',
    accent: 'bg-accent-500 text-foreground-950',
  };

  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="flex items-center gap-3">
        <span
          className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center text-xl ${accentClasses[accent]}`}
        >
          <i className={icon} />
        </span>
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-tight">
            {title}
          </h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {moreText && morePath && (
        <Link
          to={morePath}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-700 cursor-pointer whitespace-nowrap transition-colors shrink-0"
        >
          {moreText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}